import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import ReplayIcon from "@mui/icons-material/Replay";
import PetsIcon from "@mui/icons-material/Pets";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import BuildIcon from '@mui/icons-material/Build';

import type { NavKey } from "./account.types";

export const ACCOUNT_ROUTES: Array<{
    key: NavKey;
    label: string;
    icon: React.ReactNode;
    title: (firstName?: string) => string;
    subtitle: string;
}> = [
        {
            key: "dashboard",
            label: "Dashboard",
            icon: <HomeIcon fontSize="small" />,
            title: (firstName) => `Hi, ${firstName || "there"}. Welcome to your dashboard`,
            subtitle: "Manage your plan, meals, and delivery — all in one place.",
        },
        {
            key: "subscriptions",
            label: "Subscriptions",
            icon: <ReplayIcon fontSize="small" />,
            title: () => "Your subscriptions",
            subtitle: "Manage your recurring plan (powered by Recharge).",
        },
        {
            key: "extras",
            label: "Extras & Add-ons",
            icon: <AddShoppingCartIcon fontSize="small" />,
            title: () => "Extras & Add-ons",
            subtitle: "Treats and extras to complement your dog's meals.",
        },
        {
            key: "upcoming",
            label: "Upcoming deliveries",
            icon: <LocalShippingIcon fontSize="small" />,
            title: () => "Upcoming deliveries",
            subtitle: "See what’s coming next and keep your delivery on track.",
        },
        {
            key: "orders",
            label: "Order history",
            icon: <ReceiptLongIcon fontSize="small" />,
            title: () => "Your order history",
            subtitle: "View your past orders and details.",
        },
        {
            key: "address",
            label: "Delivery address",
            icon: <LocationOnIcon fontSize="small" />,
            title: () => "Delivery address",
            subtitle: "Where your next box will be delivered.",
        },
        {
            key: "payments",
            label: "Payment methods",
            icon: <CreditCardIcon fontSize="small" />,
            title: () => "Payment methods",
            subtitle: "Update your card securely for recurring deliveries.",
        },
        {
            key: "dogs",
            label: "Dogs",
            icon: <PetsIcon fontSize="small" />,
            title: () => "Your dogs",
            subtitle: "Your quiz plans saved to your account.",
        },
        {
            key: "help",
            label: "Help",
            icon: <HelpOutlineIcon fontSize="small" />,
            title: () => "Help",
            subtitle: "Need help changing meals, treats, or delivery?",
        },
        {
            key: "dev",
            label: "Dev Tools",
            icon: <BuildIcon fontSize="small" />,
            title: () => "Admin Tools",
            subtitle: "Manage customer subscriptions (admin only).",
        },
    ];

export function getRoute(key: NavKey) {
    return ACCOUNT_ROUTES.find((r) => r.key === key) || ACCOUNT_ROUTES[0];
}